import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Button,
  Typography,
  Box,
  CssBaseline,
  TextField,
  Alert,
  Snackbar,
} from "@mui/material";
import MainLayout from '../../components/layouts/MainLayout';
import AuthHttpService from '../../api/AuthHttpService';
import LoadingOverlay from '../../components/LoadingOverlay';

function RequestPasswordReset() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Por favor, preencha o email');
      return;
    }

    try {
      setLoading(true);
      await AuthHttpService.sendPasswordResetEmail(email);
      setSuccess('Um email com instruções foi enviado para você');
      setEmail('');
    } catch (error) {
      setError(error.message || 'Erro ao enviar email de recuperação');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseError = () => {
    setError('');
  };

  const handleCloseSuccess = () => {
    setSuccess('');
  };

  return (
    <MainLayout>
      <LoadingOverlay open={loading} />
      <Snackbar 
        open={!!error} 
        autoHideDuration={6000} 
        onClose={handleCloseError}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>

      <Snackbar 
        open={!!success} 
        autoHideDuration={6000} 
        onClose={handleCloseSuccess}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
          {success}
        </Alert>
      </Snackbar>

      <Container
        component="main"
        sx={{
          width: "460px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
        }}
      >
        <CssBaseline />
        
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "white",
            padding: "32px",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
            Recuperar Senha
          </Typography>

          <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}

            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                padding: '12px',
                marginBottom: '16px',
                color: '#FF6B00',
                border: `1px solid ${'#FF6B00'}`,
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(255, 107, 0, 0.04)',
                  border: `1px solid ${'#FF6B00'}`,
                },
                '&.Mui-disabled': {
                  color: '#9e9e9e',
                  border: '1px solid #9e9e9e',
                }
              }}
            >
              
              {loading ? 'Enviando...' : 'Enviar Email de Recuperação'}
            </Button>
              <p style={{color: '#FF6B00'}}>aaaaaaa</p>

            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary">
                Lembrou sua senha?{' '}
                <Link
                  to="/login"
                  style={{
                    color: '#FF6B00',
                    textDecoration: 'none',
                    fontWeight: 500,
                  }}
                >
                  Fazer login
                </Link>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Container>
    </MainLayout>
  );
}

export default RequestPasswordReset;
